<template>
  <div>
    <Carousel class="w-auto" v-bind="settings">
      <Slide v-for="(item, index) in validatedItems" :key="index" class="w-full block">
        <a :href="item.href" @click="logEvent(item)">
          <div class="h-56 md:h-56 md:px-4 flex justify-center" v-if="isImage">
            <NuxtImg
              :src="item.url"
              class="h-full object-contain"
              quality="90"
              loading="lazy"
              @error="setDefaultImage"
              alt="product image"
              title="product image"
            />
          </div>
          <div class="h-56 md:h-56 md:px-4" v-else>
            <NuxtImg
              :src="item.url"
              class="size-full"
              quality="90"
              loading="lazy"
              @error="setDefaultImage"
              alt="product image"
              title="product image"
            />
          </div>
        </a>
      </Slide>
      <template #addons>
        <Navigation v-if="!isMobile && items.length > itemsToShow" />
        <Pagination v-if="items.length > 1" />
      </template>
    </Carousel>
    <V3ImageLightboxComponent
      v-if="isImage"
      ref="lightbox"
      :data="validatedItems"
      :image_value="currentImageUrl"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const { isMobile } = useDevice();
const props = defineProps(['items', 'type']);
const itemsToShow = isMobile ? 1 : 3.2;

// Carousel settings
const settings = {
  itemsToShow,
  autoplay: props.items.length > 1 ? 8000 : 0,
  wrapAround: props.items.length > itemsToShow,
  snapAlign: props.items.length > itemsToShow ? 'center' : 'start',
};

const runtimeConfig = useRuntimeConfig();

// Fallback for broken images
const setDefaultImage = (event) => {
  event.target.src = runtimeConfig.public.defaultProductImage;
};

// Determine if items are images
const isImage = props.type?.toLowerCase() === 'image' || false;

// Manage current image URL and lightbox reference
const currentImageUrl = ref('');
const lightbox = ref(null);

// Validated items
const validatedItems = ref([]);

// Validate and update item images
const validateImages = async () => {
  const updatedItems = await Promise.all(
    props.items.map(async (item) => {
      if (item.url && (item.url.startsWith('http://') || item.url.startsWith('https://'))) {
        const validatedUrl = await useValidateThumbnailBuilder({
          thumbnail: item.url,
          gallery: [item.url],
        });

        item.url = validatedUrl || runtimeConfig.public.defaultProductImage;
        return item; 
      } else {
        return null;
      }
    })
  );
  const filteredItems = updatedItems.filter(item => item !== null);

  return filteredItems;
};

// Initialize validated items on component mount
onMounted(async () => {
  validatedItems.value = await validateImages();
});

// Log event and open lightbox
const logEvent = (item) => {
  currentImageUrl.value = item.url;

  if (lightbox.value && isImage) {
    lightbox.value.show(validatedItems.value.indexOf(item));
  }
};
</script>
